import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ConfirmationModalConfig } from '../components/ui/modal/confirmation-modal/confirmation-modal.component';

interface ModalRequest {
  config: ConfirmationModalConfig;
  resolve: (result: boolean) => void;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  private subject = new Subject<ModalRequest>();
  readonly requests$ = this.subject.asObservable();

  confirm(config: ConfirmationModalConfig): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.subject.next({ config, resolve });
    });
  }
}
